import { render, staticRenderFns } from "./card-background.svg.vue?vue&type=template&id=2a70d0c8&"
import script from "./card-background.svg.vue?vue&type=script&lang=js&"
export * from "./card-background.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports